import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-date-range-picker", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("date-range-picker", "initial-range"),
            componentTag: "ux-date-range-picker",
            performActions: async (page) => {
                await page.click(".ux-date-picker__field");
            },
            pageHeight: 500,
            pageWidth: 680,
        });
    });
});
